/**
 * VersionInfo - Shows environment and version number
 */

const VERSION = '1.02';
const IS_PRODUCTION = import.meta.env.PROD;
const ENVIRONMENT = IS_PRODUCTION ? 'Production' : 'Development';

function VersionInfo() {
  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      padding: '6px 12px',
      background: IS_PRODUCTION ? 'rgba(16, 185, 129, 0.1)' : 'rgba(59, 130, 246, 0.1)',
      border: `1px solid ${IS_PRODUCTION ? '#10b981' : '#3b82f6'}`,
      borderRadius: '6px',
      fontSize: '11px',
      color: IS_PRODUCTION ? '#065f46' : '#1e40af',
      fontWeight: '500',
      zIndex: 9999,
      userSelect: 'none'
    }}>
      {ENVIRONMENT} v{VERSION}
    </div>
  );
}

export default VersionInfo;
